import {
  FilterOperation,
  IFilterInput,
  IGoodsReceiptLine,
  IPurchaseOrderLine,
  SalesOrderLineStatus,
} from '../../graphql/schema/p4types';

export enum AllocateReceiptsFilterCondition {
  ONLY_NEW_RECEIPTS = 'Only New Receipts',
  ONLY_RECEIVED_LINES = 'Only Received Lines',
  NO_CONDITION = 'No Condition',
}

export const ALLOCATE_RECEIPTS_FIELD_NAMES = [
  'salesOrder.orderNumber',
  'salesOrder.orderDate',
  'salesOrder.orderReference',
  'salesOrder.customer.reference',
  'product.reference',
  'description',
  'quantity',
  'grossSellingPrice',
  'discountPercentage',
  'costPrice',
  'profitMargin',
  'priceOriginDescription',
  'salesOrderLineStatus',
  'allocated',
];

function isIPurchaseOrderLine(
  potentialLine: IGoodsReceiptLine | IPurchaseOrderLine
): potentialLine is IPurchaseOrderLine {
  return (potentialLine as IPurchaseOrderLine).received !== undefined;
}

export const getAllocateReceiptsFilters: (
  receiptLines: Array<IGoodsReceiptLine | IPurchaseOrderLine>,
  filterCondition: AllocateReceiptsFilterCondition
) => Array<IFilterInput> = (receiptLines, filterCondition) => {
  const predefinedFilters: Array<IFilterInput> = [
    {
      filterOperation: FilterOperation.Equals,
      filterParameters: {
        field: 'salesOrderLineStatus',
        value: SalesOrderLineStatus.AwaitingAllocation,
      },
    },
  ];

  if (receiptLines && receiptLines.length > 0) {
    let filteredReceiptLines: Array<IGoodsReceiptLine | IPurchaseOrderLine> = [];

    if (filterCondition === AllocateReceiptsFilterCondition.ONLY_RECEIVED_LINES) {
      // Only include received PO lines
      for (let i = 0; i < receiptLines.length; i++) {
        const receiptLine = receiptLines[i];
        if (isIPurchaseOrderLine(receiptLine) && receiptLine.received > 0) {
          filteredReceiptLines.push(receiptLine);
        }
      }
    } else if (filterCondition === AllocateReceiptsFilterCondition.ONLY_NEW_RECEIPTS) {
      // Only include newly received PO lines
      for (let i = 0; i < receiptLines.length; i++) {
        const receiptLine = receiptLines[i];
        if (isIPurchaseOrderLine(receiptLine) && receiptLine.newReceipt > 0) {
          filteredReceiptLines.push(receiptLine);
        }
      }
    } else if (filterCondition === AllocateReceiptsFilterCondition.NO_CONDITION) {
      filteredReceiptLines = receiptLines;
    }

    for (let i = 0; i < filteredReceiptLines.length; i++) {
      predefinedFilters.push({
        filterOperation: FilterOperation.Equals,
        filterParameters: {
          field: 'product.id',
          value: filteredReceiptLines[i]?.product?.id,
        },
      });
    }
  }

  return predefinedFilters;
};
